import React from 'react';
import { WeaLocaleProvider, WeaAlertPage } from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;

const WeaPortalNoRight = props => {
  if (props.status == -1) {
    return (
      <WeaAlertPage>
        <div style={{ color: '#000' }}>{getLabel(2012, '对不起，您暂时没有权限！')}</div>
      </WeaAlertPage>
    );
  } else {
    return <div />;
  }
};

export default WeaPortalNoRight;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-noright/index.js